<template>
	<input v-model="displayValue" type="text" class="form-control m-input" placeholder="Tín dụng cấp thêm" aria-describedby="basic-addon2">
</template>

<script>
	import { Utilities } from "../utilities";

	export default {
		props: ["value"],

		computed: {
		    displayValue: {
		        get: function() {
		        	return Utilities.currency(this.value)
		        },
		        set: function(modifiedValue) {
		            let newValue = modifiedValue.replace(/\,/g,'');
		            this.$emit('input', newValue)
		        }
		    }
		}
	}

</script>